import { Component } from '@angular/core';
import { KeyboardActivityBaseComponent } from '../keyboard-activity-base.component';
import { BasicKeyboardActivity } from '../basic-keyboard-activity';

@Component({
  selector: 'lib-keyboard-visual-stimulus-activity',
  imports: [KeyboardActivityBaseComponent],
  templateUrl: './keyboard-visual-stimulus.component.html',
})
export class KeyboardVisualStimulusComponent extends BasicKeyboardActivity {}
